import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { CustomTextBox } from "component/ui/CustomTextbox";

const DepartmentFormDialog = ({
  open,
  mode = "create",
  name = "",
  onNameChange,
  onClose,
  onSubmit,
  submitting = false,
}) => {
  const isCreate = mode === "create";
  const title = isCreate ? "New department" : "Edit department";
  const submitLabel = isCreate ? "Create" : "Save";

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !submitting) {
      e.preventDefault();
      onSubmit?.();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <CustomTextBox
          autoFocus
          name={isCreate ? "departmentName" : "departmentNameEdit"}
          label="Department name"
          value={name}
          casing="caps"
          onChange={(e) => onNameChange?.(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={{ mt: 1 }}
          disabled={submitting}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <LoadingButton variant="contained" onClick={onSubmit} loading={submitting}>
          {submitLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DepartmentFormDialog;
